<template>
  <div>
    <!--搜索栏-->
    <searchBar
      :search-form="searchForm"
      title
      travelTypeId
      btn-add
      :travelType="typeList"
      @handleAdd="handleAdd"
      @handleSearch="getData"
    ></searchBar>

    <!--表格-->
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>
      <el-table-column label="图片" align="center" width="140">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px;"
            :src="serverUrl + scope.row.cover"
            :preview-src-list="getImgPreviewList(scope.row.cover)"
          ></el-image>
        </template>
      </el-table-column>

      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="240">
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="mini">
            编辑
          </el-button>
          <el-button @click="handleDetail(scope.row)" type="text" size="mini">
            详情
          </el-button>
          <el-button
            @click="handleEnabled(scope.row)"
            type="text"
            :style="{ color: scope.row.status === 1 ? 'red' : '' }"
            size="mini"
          >
            {{ scope.row.status === 1 ? "禁用" : "启用" }}
          </el-button>
          <el-button
            @click="handleDelete(scope.row)"
            type="text"
            style="color:red"
            size="mini"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>

    <!--新增Dialog-->
    <el-dialog
      title="添加/修改秀水周边信息"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
      >
        <el-form-item label="标题" prop="title" label-width="100px">
          <el-input
            v-model="form.title"
            size="medium"
            placeholder="标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="旅游类型"
          style="text-align: left"
          prop="type"
          label-width="100px"
        >
          <el-select
            v-model="form.type"
            placeholder="选择类型"
            style="width: 200px;"
            clearable
          >
            <el-option
              :label="item.name"
              v-for="(item, index) in optionType"
              :key="index"
              :value="item.uid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址" prop="address" label-width="100px">
          <el-input
            v-model="form.address"
            size="medium"
            placeholder="地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobile" label-width="100px">
          <el-input
            v-model="form.mobile"
            size="medium"
            placeholder="联系电话"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="主图"
          style="text-align: left"
          prop="images"
          label-width="100px"
        >
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :before-upload="imgDefault"
            accept="image/*"
          >
            <img
              class="avatar"
              v-if="form.images"
              :src="serverUrl + form.images"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item> -->
        <el-form-item label="主图" style="text-align: left" prop="images">
          <div style="display:flex;">
            <div v-for="(item, index) in form.images" class="img-list">
              <img v-if="item" :src="serverUrl + item" class="avatar" />
              <div @click="handleRemove(index)">
                <i class="el-icon-delete" style="cursor: pointer;"></i>
              </div>
            </div>
            <el-upload
              class="avatar-uploader"
              action="#"
              :show-file-list="false"
              :before-upload="imgDefault"
            >
              <i
                v-if="form.images.length < 3"
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item
          label="封面图"
          style="text-align: left"
          prop="cover"
          label-width="100px"
        >
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :before-upload="coverDefault"
          >
            <img
              v-if="form.cover"
              :src="serverUrl + form.cover"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <p>点击上传</p>
          </el-upload>
        </el-form-item>
        <el-form-item label="介绍" label-width="100px" prop="content">
          <quill-editor
            style="text-align: left;"
            v-model="form.content"
            ref="myQuillEditor"
            :options="editorOption"
            @focus="onEditorFocus($event)"
            @blur="onEditorBlur($event)"
            @change="onEditorChange($event)"
          ></quill-editor>
        </el-form-item>
        <el-form-item label="费用信息" label-width="100px" prop="cost">
          <quill-editor
            style="text-align: left;"
            v-model="form.cost"
            ref="myQuillEditor"
            :options="editorOption"
            @focus="onEditorFocus($event)"
            @blur="onEditorBlur($event)"
            @change="onEditorChange($event)"
          ></quill-editor>
        </el-form-item>
        <el-form-item label="营业时间" label-width="100px" prop="opening">
          <quill-editor
            style="text-align: left;"
            v-model="form.opening"
            ref="myQuillEditor"
            :options="editorOption"
            @focus="onEditorFocus($event)"
            @blur="onEditorBlur($event)"
            @change="onEditorChange($event)"
          ></quill-editor>
        </el-form-item>
        <el-form-item label="注意事项" label-width="100px" prop="attention">
          <quill-editor
            style="text-align: left;"
            v-model="form.attention"
            ref="myQuillEditor"
            :options="editorOption"
            @focus="onEditorFocus($event)"
            @blur="onEditorBlur($event)"
            @change="onEditorChange($event)"
          ></quill-editor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog> -->
    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="dialogDetail">
      <Details :detail="detailData" :type="'trave'"></Details>
    </el-dialog>
  </div>
</template>

<script>
import { downloadFile } from "@/assets/http/utils"
import Axios from "axios"
import apiUrl from "@/assets/http/apiUrl"
import Details from "@/components/details/index.vue"
import { quillEditor } from "vue-quill-editor"
import "quill/dist/quill.snow.css"
import { quillRedefine } from "vue-quill-editor-upload"
export default {
  name: "productManager",
  components: {
    quillEditor,
    quillRedefine,
    Details,
  },
  data() {
    let Self = this

    // 表单验证
    let validateMobile = (rule, value, callback) => {
      if (/^1[3456789]\d{9}$/.test(value)) {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("手机号验证失败"))
      }
    }
    let validateIdCard = (rule, value, callback) => {
      if (
        /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          value
        )
      ) {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("身份证号验证失败"))
      }
    }
    let validateAvatar = (rule, value, callback) => {
      if (Self.form.image !== "") {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("请上传图片"))
      }
    }

    return {
      // 页面初始数据
      totalElements: 10,
      totalPages: 1,
      size: 10,
      page: 1,
      travelType: "",
      typeList: [],
      serverUrl: apiUrl.ServerUrl,
      dialogDetail: false,
      detailData: {},
      // 搜索栏初始化
      searchForm: {
        title: "",
        status: "",
        travelTypeId: "",
      },

      // 表头初始化
      tableHeader: {
        title: "标题",
        typeName: "类型",
        address: "地址",
      },

      // 表格数据
      tableData: [],

      // dialog可见性
      dialogFormVisible: false,
      dialogUploadVisible: false,

      // 上传文件列表
      file: "",
      // 大图上传
      bigImg: "",
      props: {
        value: "uid",
        label: "name",
      },
      optionType: [],
      // 新增表单
      form: {
        uid: "",
        title: "",
        type: "",
        cover: "",
        images: [],
        content: "",
        mobile: "",
        address: "", //地址
        cost: "", //费用信息
        opening: "", //营业时间
        attention: "", //注意事项
      },

      // 表单验证规则
      rules: {
        title: {
          required: true,
          message: "请输入旅游标题",
          trigger: "blur",
        },
        type: {
          required: true,
          message: "请选择类型",
          trigger: "blur",
        },
        address: {
          required: true,
          message: "请输入地址",
          trigger: "blur",
        },
        mobile: {
          required: true,
          message: "请输入联系电话",
          trigger: "blur",
        },
        content: {
          required: true,
          message: "请输入内容",
          trigger: "blur",
        },
        images: {
          required: true,
          validator: validateAvatar,
          trigger: "blur",
        },
        cover: {
          required: true,
          validator: validateAvatar,
          trigger: "blur",
        },
      },
      dialogImageUrl: "",
      //上传图片
      serverUrl: apiUrl.ServerUrl,
      uploadAvatarServer: apiUrl.UploadFile,
      bannarImgUrl: "",
      coverImgUrl: "",
      // 编辑器配置
      editorOption: {
        placeholder: "请详细填写活动内容",
        modules: {
          toolbar: [
            "bold",
            "italic",
            "underline",
            "strike",
            "align",
            "link",
            "image",
          ],
        },
      },
    }
  },
  methods: {
    //上传单位图片成功的回调
    handleBannarSuccess(res) {
      // this.form.images = this.form.images.push(res.data.url)
      this.form.images = res
      this.bannarImgUrl = apiUrl.ServerUrl + this.form.images
    },
    handleCoverSuccess(res) {
      console.log(res)
      this.form.cover = res
      this.coverImgUrl = apiUrl.ServerUrl + this.form.cover
    },
    //上传图片之前的回调
    beforeAvatarUpload(file) {
      const isJPGorPNG =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png"
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPGorPNG) {
        this.$message.error("上传图片只能是 JPG或PNG 格式!")
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!")
        alert("上传图片大小不能超过 2MB!")
      }
      return isJPGorPNG && isLt2M
    },
    /*图片预览*/
    getImgPreviewList(url) {
      let arr = new Array(this.serverUrl + url)
      return arr
    },

    /*请求数据
     * */
    getData() {
      this.request({
        url: "/manager/travel/findTravelInfoPage",
        method: "get",
        params: {
          page: this.page,
          size: this.size,
          type: this.searchForm.travelTypeId,
          title: this.searchForm.title,
          status: this.searchForm.status,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages

          this.tableData = res.data.data.content
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    // 获取类型下拉列表
    getTypeList() {
      this.request({
        url: "/manager/travel/getTravelTypeList",
        method: "get",
        params: {},
      })
        .then(res => {
          this.typeList = res.data.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    /*获取周游秀水类型
     * */
    getType() {
      this.request({
        url: "/manager/travel/getTravelTypeList",
        method: "get",
        params: {},
      })
        .then(res => {
          this.optionType = res.data.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    // 准备富文本编辑器
    onEditorReady(editor) {},
    // 富文本编辑器 失去焦点事件
    onEditorBlur(editor) {},
    // 富文本编辑器 获得焦点事件
    onEditorFocus(editor) {},
    // 富文本编辑器 内容改变事件
    onEditorChange(editor) {
      this.form.conditions = editor.html
    },

    /*更改单页数据数量
     * */
    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    /*页码跳转
     * */
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },

    /*启用/禁用
     * */
    handleEnabled(rowData) {
      let status = rowData.status === 1 ? 2 : 1
      this.request({
        url: "/manager/travel/updateTravelInfoStatus",
        data: {
          uid: rowData.uid,
          status: status,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*编辑
     * */
    handleEdit(rowData) {
      this.form = {
        ...rowData,
      }
      if (rowData.images && rowData.images.length != 0) {
        this.bannarImgUrl = apiUrl.ServerUrl + rowData.images[0]
      }
      if (rowData.cover) {
        this.coverImgUrl = apiUrl.ServerUrl + rowData.cover
      }
      this.form.type = rowData.type
      this.dialogFormVisible = true
    },
    // 详情
    handleDetail(rowData) {
      this.detailData = this.request({
        url: "/manager/travel/travelInfoDetail",
        params: {
          uid: rowData.uid,
        },
        method: "get",
      })
        .then(res => {
          this.dialogDetail = true
          this.detailData = res.data.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*添加商户前的处理
     * 需要将options中的'全部'一项给去掉
     * 因为是必填项*/
    handleAdd() {
      this.dialogFormVisible = true
    },

    /*删除
     * */
    handleDelete(rowData) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/travel/deleteTravelInfo",
            params: {
              uid: rowData.uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },
    handleRemove(index) {
      this.form.images.splice(index, 1)
    },

    /*dialog提交
     * */
    dialogConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.dialogFormVisible = false
          this.request({
            url: "/manager/travel/addOrUpdateTravelInfo",
            data: this.form,
            method: "post",
          })
            .then(res => {
              if (res.data.status === "BAD_REQUEST") {
                this.$message.warning(res.data.message)
              }
              // this.form = {}
              this.getData()
              this.dialogCancel()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        }
      })
    },

    /*dialog取消
     * */
    dialogCancel() {
      this.form = {
        uid: "",
        title: "",
        type: "",
        cover: "",
        images: [],
        content: "",
        mobile: "",
        address: "", //地址
        cost: "", //费用信息
        opening: "", //营业时间
        attention: "", //注意事项
      }
      this.dialogFormVisible = false
      this.$refs.form.resetFields()
    },

    /*覆盖默认上传请求
     * */
    overwriteDefault(e) {
      let tmpFile = new FormData()
      tmpFile.append("file", e.file)
      this.file = tmpFile
      Axios.post(apiUrl.server + "/manager/upload/uploadPic", this.file, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
        .then(res => {
          if (res.data.status === "OK") {
            this.$message.success("上传成功")
            this.form.cover = res.data.data
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    // 上传bannar图
    imgDefault(e) {
      let tmpFile = new FormData()
      tmpFile.append("file", e)
      tmpFile.append("folder", "notify")
      Axios.post(apiUrl.server + "/manager/upload/uploadFile", tmpFile)
        .then(res => {
          // this.form.images = res.data
          this.form.images.push(res.data)
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    //上传封面图
    coverDefault(e) {
      let tmpFile = new FormData()
      tmpFile.append("file", e)
      tmpFile.append("folder", "notify")
      Axios.post(apiUrl.server + "/manager/upload/uploadFile", tmpFile)
        .then(res => {
          // console.log(res.data)
          this.form.cover = res.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    uploadCancel() {
      this.dialogUploadVisible = false
      this.form = {}
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
  },
  mounted() {
    this.getData()
    this.getType()
    this.getTypeList()
  },
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px solid #c0c4cc;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  margin-right: 10px;
}
.avatar-uploader-icon {
  font-size: 28px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.img-list {
  text-align: center;
}
</style>
